import { Group, Radio } from '@mantine/core';

/**
 * Returns radiobuttons with value selection (2-5)
 * @param onChange: Callback function
 * @param value: initial value
 * @param label: label string 
 * @returns JSX.Element
 */
function NumSelect(props: {
	onChange: any;
	value: string;
	label: string;
}): JSX.Element {
	const { onChange, value, label } = props;

	return (
		<>
			<Radio.Group
				label={label}
				onChange={onChange}
				value={value}
			>
				<Group mt="xs">
					<Radio value="2" label="2" />
					<Radio value="3" label="3" />
					<Radio value="4" label="4" />
					<Radio value="5" label="5" />
				</Group>
			</Radio.Group>
		</>
	);
}

export default NumSelect;